import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {AbstractProdGrid, IProdGrid, ProdGridColumnTransforms, ProdGridColumnType} from 'prod-grid';
import {DeviceEventService} from "../../../../services/device-event.service";
import {DipColumn} from "../../../../dip/dip-column";
import {ProdDialogData} from 'prod-dialog';
import {HttpExtraParams, HttpFilterParam} from "prod-shared";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-heartbeat-grid',
  templateUrl: './heartbeat-grid.component.html'
})
export class HeartbeatGridComponent extends AbstractProdGrid implements IProdGrid {
  @Input() dialogData: ProdDialogData;
  prodGridTitle = this.translate.instant('heartbeats.grid-title');
  prodGridColumns: DipColumn[] = [
    DipColumn.get({
      property: 'createdAt',
      type: ProdGridColumnType.DATE,
      transform: {
        transform: ProdGridColumnTransforms.DATETIME
      }
    })
  ];

  constructor(protected override changeDetectorRef: ChangeDetectorRef, override prodGridDataService: DeviceEventService, private translate: TranslateService) {
    super(changeDetectorRef);
  }

  override ngOnInit() {
  }

  override loadProdGridData(httpExtraParams?: HttpExtraParams): void {
    let devices: number[] = [];
    if (this.dialogData.data.records) {
      this.dialogData.data.records.getAll().forEach(hub => devices.push(hub.id));
    }

    super.loadProdGridData(HttpExtraParams.addFilter(httpExtraParams, new HttpFilterParam({
      property: 'device.id',
      operator: 'in',
      value: devices
    })));
  }
}
